import { render, staticRenderFns } from "./OutRulesPopup.vue?vue&type=template&id=a6635bb0&scoped=true&"
import script from "./OutRulesPopup.vue?vue&type=script&lang=ts&"
export * from "./OutRulesPopup.vue?vue&type=script&lang=ts&"
import style0 from "./OutRulesPopup.vue?vue&type=style&index=0&id=a6635bb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6635bb0",
  null
  
)

export default component.exports